
import { Options, Vue } from 'vue-class-component';
import News from '@/components/News.vue';
import Logo from "@/base-components/Logo.vue"; // @ is an alias to /src

@Options({
  components: {
    News,
    Logo
  },
})
export default class NewsView extends Vue {}
